import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_oval_circle_o",
  "use": "icon-home_oval_circle_o-usage",
  "viewBox": "0 0 240 178",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 240 178\" id=\"icon-home_oval_circle_o\">\n    <path stroke=\"#FEB100\" stroke-width=\"1.5\" d=\"M61.866 168.939c-39.847 8.034-49.48-34.196-22.239-82.995C101.493-6.621 199.22 20.88 214.126 39.187c14.905 18.307 2.931 40.263-54.496 49.869-57.427 9.606-47.954 69.84-97.764 79.883z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol